<div class="list">
  <div class="actions">
    <a *ngIf="!!user.superuser || authService.hasPermission('admin')" visibleByBrand="maja" uiSref="symap.project.geometricPlanRequests.createFromExisting" class="button">
      <i class="fa fa-plus-square"></i>Propojit existující db záznam o GP
    </a>
    <a [gmtAuth]="'manage_geometric_plans'" uiSref="symap.project.geometricPlanRequests.create" class="button">
      <i class="fa fa-plus-square"></i>Založit záznam o zpracování GP
    </a>
    <a [gmtAuth]="'manage_geometric_plans'" uiSref="symap.project.geometricPlanRequests.createFromPrepared" class="button">
      <i class="fa fa-plus-square"></i>Vložit vyhotovený GP
    </a>
  </div>

  <h1>Geometrické plány</h1>
  <filter [list]="list" (onChanged)="pageableList.onFilterChanged($event)">

    <!-- katastralni uzemi -->
    <gmt-select
      resource="areas"
      [filter]="{ sortOrder: { sortBy: 'name' }}"
      [data]="list.filter.filters.areaId"
      field="values"
      [multiselect]="true"
      selectTitle="Katastrální území"
    ></gmt-select>

    <!-- stavebni objekt -->
    <gmt-select
      resource="construction-objects"
      [filter]="{ filters: { validity: 'valid' }, sortOrder: { sortBy: 'socis' }}"
      [data]="list.filter.filters.constructionObjectId"
      field="values"
      [multiselect]="true"
      [itemPipe]="constructionObjectNamePipe"
      selectTitle="{{ 'CONSTRUCTION_OBJECT' | wordtranslate:true }}"
    ></gmt-select>

    <!-- parcely -->
    <gmt-select
      resource="parcels"
      [filter]="{ filters: { validity: 'valid' }}"
      [data]="list.filter.filters.parcelId"
      field="values"
      [multiselect]="true"
      [itemPipe]="parcelNumberPipe"
      selectTitle="Parcela"
    ></gmt-select>

    <!-- typ gp -->
    <gmt-select
      [optionItems]="typeOptions"
      [data]="list.filter.filters.type"
      field="values"
      [multiselect]="true"
      selectTitle="Typ GP"
    ></gmt-select>

    <!-- stav gp -->
    <gmt-select
      [optionItems]="statusOptions"
      [data]="list.filter.filters.status"
      field="values"
      [multiselect]="true"
      selectTitle="Stav GP"
    ></gmt-select>

    <div class="tag" [ngClass]="{ active: !list.filter.filters.deleted.values.length }" title="Zobrazení vč. GP, které jsou smazané" (click)="onToggleDeleted()">
      <div>Zobrazit zrušené GP</div>
    </div>

    <div>
      <input class="fulltext" type="text" placeholder="Fultextové hledání..." [(ngModel)]="list.filter.filters.searchText.values[0].id"/>
    </div>
  </filter>

  <div [loading]="list.loading || !settingsLoaded">
    <div class="table-top-container">
      <div class="flex1"><gmt-button [clickAction]="onExport" [gmtDisabled]="!exportEnable"><i class="fa fa-download"></i> Exportovat seznam</gmt-button></div>
      <pagescounter *ngIf="list.itemCount && settingsLoaded && list.list !== null" [list]="list" (callbackRegister)="pageableList.pagescounterCallbackRegister($event)"></pagescounter>
      <div class="page-count-select" *ngIf="list.itemCount && settingsLoaded && list.list !== null">
        <span>Záznamů na stránce</span>
        <gmt-select required="true" [data]="pageableList.dataPaging" field="itemsPerPage" [optionItems]="pageableList.itemsPerPageItems" (changed)="pageableList.changePageItems()" class="min-width-unset"></gmt-select>
      </div>
    </div>

    <table-geometric-plan-request [list]="list" (sort)="pageableList.onSort($event.column, $event.ascOrDesc)" *ngIf="settingsLoaded"></table-geometric-plan-request>

    <div class="empty-info bordered pb-20 pt-20 centered-text" *ngIf="!list.itemCount && list.list !== null && !list.loading">
      <span>Nebyla nalezena žádná data.</span>
    </div>
  </div>

  <itemscounter
    *ngIf="list.itemCount && list.list !== null" [list]="list"
    (callbackRegister)="pageableList.itemcounterCallbackRegister($event)"
    style="max-width: 100px;"
  ></itemscounter>

  <pagination
    *ngIf="list.itemCount && list.list !== null"
    [list]="list"
    (callbackRegister)="pageableList.paginationCallbackRegister($event)"
  ></pagination>

  <help [helpId]="helpIds.GEOMETRIC_PLAN_REQUEST_LIST" class="cm-help-page"></help>
</div>
